export default "__VITE_ASSET__260da6fb__"